module.exports = __webpack_public_path__ + "img/oran_3kl.04272e31.jpg";